export default __webpack_public_path__ + "static/media/Mark-6-HUD-Pop-Up (System Repair).3a69eadf.jpg";